module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-5.6a40800c.png";